import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  layoutTheme: ''
});

const themeSettingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_LAYOUT_TYPE_THEME:
      return state.set('layoutTheme', action.payload);
    default:
      return state;
  }
};
export default themeSettingReducer;
